import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  :root {\n    --text-color-primary: ",
        ";\n    --text-color-secondary: ",
        ";\n  }\n\n  body {\n    background-color: ",
        ";\n  }\n\n  * {\n    font-family: ",
        ";\n    color: var(--text-color-primary);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  height: 100vh;\n\n  .form-section {\n    flex-grow: 1;\n\n    height: 100%;\n    max-width: 640px;\n    background: white;\n  }\n\n  .image-section {\n    position: relative;\n    flex-grow: 1;\n  }\n\n  @media (max-width: 700px) {\n    .image-section {\n      display: none;\n    }\n\n    .form-section {\n      max-width: 100%;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  height: ",
        ";\n  justify-content: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  form {\n    display: flex;\n    flex-direction: column;\n\n    width: 330px;\n    max-width: 400px;\n    margin-bottom: 37px;\n\n    ",
        "\n  }\n\n  label {\n    display: flex;\n    flex-direction: column;\n    font-size: 16px;\n    margin-bottom: 28px;\n  }\n\n  label > input {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n    border-bottom: 1px solid ",
        ";\n    line-height: 48px;\n    color: fieldtext;\n  }\n\n  label > input::placeholder {\n    color: var(--text-color-secondary);\n  }\n\n  label:last-of-type {\n    margin-bottom: 15px;\n  }\n\n  form > button {\n    display: inline-block;\n\n    margin-top: 14px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  @media (max-width: 700px) {\n    form {\n      display: flex;\n      flex-direction: column;\n\n      min-width: inherit;\n    }\n\n    form > button {\n      width: 100%;\n      margin-left: 0px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  font-size: 37px;\n  margin-bottom: 37px;\n\n  @media (max-width: 700px) {\n    font-size: 30px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { postJSON } from "@purple-dot/libraries/src/fetch";
import { connectToPlacementParent } from "@purple-dot/placement-iframe";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import styled, { createGlobalStyle, ThemeProvider } from "styled-components";
import Branding from "../../components/common/Branding";
import { routeTo } from "../../components/common/linking";
import ShopperImage from "../../components/shopper/images/ShopperImage.jpg";
import ShopperPage from "../../components/shopper/ShopperPage";
import Logo from "../../components/shopper/svgs/Logo.svg";
import ShopperThemedButton from "../../components/shopper/ThemedButton";
import { useTranslation } from "../../components/use-translation";
import expressPage from "../../webserver-page";
function SelfServicePage(param) {
    var embedded = param.embedded, overlayData = param.overlayData;
    useEffect(function() {
        if (embedded) {
            connectToPlacementParent().then(function() {
            // Connect to the parent to simply resize the iframe
            // no need to store the connection
            });
        }
    }, []);
    if (embedded) {
        return /*#__PURE__*/ _jsxs(ShopperPage, {
            pageName: "Embedded self-service",
            embedded: embedded,
            children: [
                /*#__PURE__*/ _jsx(GlobalCSS, {
                    globalCSS: overlayData.head.globalCSS
                }),
                /*#__PURE__*/ _jsxs(ThemeProvider, {
                    theme: overlayData.theme,
                    children: [
                        /*#__PURE__*/ _jsx(GlobalStyle, {}),
                        /*#__PURE__*/ _jsx(LookupFormContainer, {
                            embedded: embedded,
                            children: /*#__PURE__*/ _jsx(LookupForm, {
                                embedded: embedded
                            })
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(ShopperPage, {
        pageName: "Self-service",
        children: [
            /*#__PURE__*/ _jsx(GlobalCSS, {}),
            /*#__PURE__*/ _jsxs(ThemeProvider, {
                theme: overlayData.theme,
                children: [
                    /*#__PURE__*/ _jsx(GlobalStyle, {}),
                    /*#__PURE__*/ _jsx(PageLayout, {
                        children: /*#__PURE__*/ _jsx(LookupFormContainer, {
                            children: /*#__PURE__*/ _jsx(LookupForm, {})
                        })
                    })
                ]
            })
        ]
    });
}
var GlobalCSS = createGlobalStyle(_templateObject(), function(param) {
    var globalCSS = param.globalCSS;
    return globalCSS || "";
});
var GlobalStyle = createGlobalStyle(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.header.color;
}, function(param) {
    var theme = param.theme;
    return theme.text.body.color;
}, function(param) {
    var theme = param.theme;
    return theme.modal.backgroundColor;
}, function(param) {
    var theme = param.theme;
    return theme.text.body.fontFamily;
});
var PageLayout = styled(function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "form-section",
                children: children
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "image-section",
                children: /*#__PURE__*/ _jsx(Image, {
                    src: ShopperImage,
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "left",
                    quality: 90,
                    placeholder: "blur",
                    priority: true
                })
            })
        ]
    });
})(_templateObject2());
var LookupFormContainer = styled.div(_templateObject3(), function(param) {
    var embedded = param.embedded;
    return embedded ? "fit-content" : "100vh";
});
var LookupForm = styled(function(param) {
    var className = param.className, embedded = param.embedded;
    var ref = useState(""), reference = ref[0], setReference = ref[1];
    var ref1 = useState(""), email = ref1[0], setEmail = ref1[1];
    var ref2 = useState(null), error = ref2[0], setError = ref2[1];
    var ref3 = useState(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = useTranslation(), t = ref4.t, i18n = ref4.i18n;
    useEffect(function() {
        var explicitLocale = new URLSearchParams(window.location.search).get("locale");
        var browserLocale = window.navigator.language.split("-")[0];
        var locale = explicitLocale || browserLocale;
        if (locale) {
            i18n.changeLanguage(locale);
        }
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        id: "shopper-portal-login",
        children: [
            /*#__PURE__*/ _jsxs(HideForEmbedded, {
                embedded: embedded,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            maxWidth: "167px",
                            marginBottom: "40px",
                            marginLeft: "3px"
                        },
                        children: /*#__PURE__*/ _jsx(Logo, {})
                    }),
                    /*#__PURE__*/ _jsx(FormTitle, {
                        children: t("translation:self-service.index.find-your-pre-order")
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("form", {
                onSubmit: function() {
                    var _ref = _async_to_generator(function(e) {
                        var ref, success, redirect, err;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    e.preventDefault();
                                    setLoading(true);
                                    return [
                                        4,
                                        postJSON("/shopper/lookup".concat(window.location.search), {
                                            email: email,
                                            reference: reference,
                                            embedded: embedded,
                                            locale: i18n.resolvedLanguage
                                        })
                                    ];
                                case 1:
                                    ref = _state.sent(), success = ref.success, redirect = ref.redirect, err = ref.error;
                                    if (success) {
                                        routeTo(redirect);
                                    } else {
                                        setLoading(false);
                                        setError(err);
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: [
                    /*#__PURE__*/ _jsxs("label", {
                        htmlFor: "lookup-reference",
                        children: [
                            t("translation:self-service.index.reference-number"),
                            /*#__PURE__*/ _jsx("input", {
                                id: "lookup-reference",
                                "data-testid": "lookup-reference",
                                type: "text",
                                name: "reference",
                                placeholder: "#PD123456",
                                value: reference,
                                onChange: function(e) {
                                    return setReference(e.target.value);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("label", {
                        htmlFor: "lookup-email",
                        children: [
                            t("translation:self-service.index.email"),
                            /*#__PURE__*/ _jsx("input", {
                                id: "lookup-email",
                                "data-testid": "lookup-email",
                                type: "text",
                                name: "email",
                                value: email,
                                onChange: function(e) {
                                    return setEmail(e.target.value);
                                }
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ _jsx("p", {
                        "data-testid": "lookup-error",
                        style: {
                            color: "red"
                        },
                        children: error
                    }),
                    /*#__PURE__*/ _jsx(ShopperThemedButton, {
                        "data-testid": "lookup-submit",
                        type: "submit",
                        embedded: embedded,
                        disabled: loading,
                        children: t("translation:self-service.index.find-pre-order-cta")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(HideForEmbedded, {
                embedded: embedded,
                children: /*#__PURE__*/ _jsx(Branding, {})
            })
        ]
    });
})(_templateObject4(), function(param) {
    var embedded = param.embedded;
    return embedded && "\n      position: relative;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    ";
}, function(param) {
    var theme = param.theme;
    return theme.borderColor;
});
var FormTitle = styled.h3(_templateObject5());
function HideForEmbedded(param) {
    var children = param.children, embedded = param.embedded;
    return embedded ? null : children;
}
export default expressPage(SelfServicePage);
